import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { InputTextModule } from 'primeng/inputtext'
import { SelectButtonModule } from 'primeng/selectbutton'
import { InputWithSelectorComponent } from './input-with-selector.component'

@NgModule({
  declarations: [InputWithSelectorComponent],
  imports: [CommonModule, InputTextModule, SelectButtonModule, FormsModule],
  exports: [InputWithSelectorComponent],
})
export class InputWithSelectorModule {}
